/**
 * 価格を万円単位でフォーマット（内部関数）
 * @param {number} price 価格（円）
 * @returns {string}
 */
const formatPrice = (price) => {
    if (!price || price === 0) return "0000";
    const manYen = Math.round(price / 10000);
    return manYen.toLocaleString();
};

/**
 * 結果を表示
 * @param {number} price 価格（円）
 * @param {HTMLElement} resultElement 結果表示要素
 */
export const displayResult = (price, resultElement) => {
    if (resultElement) {
        resultElement.textContent = formatPrice(price);
    }
};

/**
 * エラーを表示
 * @param {HTMLElement} resultElement 結果表示要素
 */
export const displayError = (resultElement) => {
    if (resultElement) {
        resultElement.textContent = "0000";
    }
};

/**
 * ローディング状態の表示
 * @param {boolean} isLoading ローディング中かどうか
 * @param {HTMLElement} resultElement 結果表示要素
 */
export const setLoadingState = (isLoading, resultElement) => {
    if (resultElement) {
        if (isLoading) {
            resultElement.textContent = "計算中...";
        }
    }
};
